var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6675 14.6665H15.6142L15.2408 14.3065C16.8408 12.4399 17.6675 9.89319 17.2142 7.18652C16.5875 3.47986 13.4942 0.519858 9.76083 0.0665242C4.12083 -0.626809 -0.625833 4.11986 0.0675008 9.75986C0.520834 13.4932 3.48083 16.5865 7.1875 17.2132C9.89417 17.6665 12.4408 16.8399 14.3075 15.2399L14.6675 15.6132V16.6665L20.3342 22.3332C20.8808 22.8799 21.7742 22.8799 22.3208 22.3332C22.8675 21.7865 22.8675 20.8932 22.3208 20.3465L16.6675 14.6665ZM8.6675 14.6665C5.3475 14.6665 2.6675 11.9865 2.6675 8.66652C2.6675 5.34652 5.3475 2.66652 8.6675 2.66652C11.9875 2.66652 14.6675 5.34652 14.6675 8.66652C14.6675 11.9865 11.9875 14.6665 8.6675 14.6665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.89a45170d5e45a539be3b202841c24fc.svg";
export { ForwardRef as ReactComponent };